import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M17 4h-3V2h-4v2H7v5h4.93L13 7v2h4V4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 12.5h2L11 20v-5.5H9L11.93 9H7v13h10V9h-4v3.5z"
})), 'BatteryCharging80Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BatteryCharging80Sharp.js
// module id = 2301
// module chunks = 2